{
  "version": 1,
  "asset_id": "891dbe7d-900c-4f09-98b5-2ad3e5981797",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/891dbe7d-900c-4f09-98b5-2ad3e5981797/cargo-thumb.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/891dbe7d-900c-4f09-98b5-2ad3e5981797/cargo-thumb.webp",
  "original_filename": "cargo-thumb.webp",
  "size": 2622,
  "content_type": "image/webp",
  "created_at": "2026-07-28T02:24:46Z"
}
